import type { KeyMetricsExpenseDTO } from "../models/keyMetricsExpenseDto";
import type { KeyMetricsExpenseEntity } from "../../domain/entities/KeyMetricsExpenseEntity";

export function keyMetricsExpenseDtoToEntity(
  dto: KeyMetricsExpenseDTO
): KeyMetricsExpenseEntity {
  return {
    ytdExpense: Number(dto.ytdExpense) || 0,
    ytdSubtext: String(dto.ytdSubtext ?? ""),
    dpoAvgDays: dto.dpoAvgDays != null ? Number(dto.dpoAvgDays) : undefined,
    dpoChangeDays:
      dto.dpoChangeDays != null ? Number(dto.dpoChangeDays) : undefined,
    dpoChangeVariant:
      dto.dpoChangeVariant === "up" || dto.dpoChangeVariant === "down"
        ? dto.dpoChangeVariant
        : null,
    dpoStatus:
      dto.dpoStatus === "excellent" ||
      dto.dpoStatus === "healthy" ||
      dto.dpoStatus === "watch" ||
      dto.dpoStatus === "critical"
        ? dto.dpoStatus
        : undefined,
    dpoStatusLabel: String(dto.dpoStatusLabel ?? "Healthy"),
    dpoWindowMonths:
      dto.dpoWindowMonths != null ? Number(dto.dpoWindowMonths) : undefined,
    dpoWindowLabel:
      dto.dpoWindowLabel != null ? String(dto.dpoWindowLabel) : undefined,
    gaugeValue: Number(dto.gaugeValue) || 0,
    gaugeValueUnit: String(dto.gaugeValueUnit ?? "%"),
    gaugeClosedMonthLabel:
      dto.gaugeClosedMonthLabel != null && dto.gaugeClosedMonthLabel !== ""
        ? String(dto.gaugeClosedMonthLabel)
        : undefined,
    gaugeBadgeLabel: String(dto.gaugeBadgeLabel ?? "Healthy"),
    currencySymbol: String(dto.currencySymbol ?? "₹"),
  };
}
